const alphaRenzhiFields = [
  {
    label: '股东背景',
    value: '股东背景',
    placeholder: '该公司是国资背景，还是外资背景',
  },
  {
    label: '领导风格',
    value: '领导风格',
    placeholder: '“ 公司高管/分管领导是谁？是XX总吗？分管领导是什么风格？前几任是谁 ”',
  },
  {
    label: '公司规模和市场排名',
    value: '公司规模和市场排名',
    placeholder: '',
  },
  {
    label: '公司部门设置',
    value: '公司部门设置',
    placeholder: '“ 业务条线是怎么划分的?分为几个部门？ ”',
  },
  {
    label: '公司业务风格',
    value: '公司业务风格',
    placeholder: '“ 每个团队的风格是？哪个团队的业绩最好？”',
  },
  {
    label: '公司优劣势',
    value: '公司优劣势',
    placeholder: '',
  },
  {
    label: '最近变动',
    value: '最近变动',
    placeholder: '“有人离开吗？最近都有谁走了 ”',
  },
]
const cateRenzhiFields = [
  {
    label: '部门架构',
    value: '部门架构',
    placeholder: '“ 部门总共有多少人？业务条线怎么分？有几个组？几个团队？ ”',
  },
  {
    label: '团队长',
    value: '团队长',
    placeholder: '“ 咱们每个团队团队长是谁？什么风格？ ”',
  },
  {
    label: 'A类人选',
    value: 'A类人选',
    placeholder: '“ 咱们部门哪个人素质最好/能力最强/业绩最好 ？”',
  },
  {
    label: '业务风格',
    value: '业务风格',
    placeholder: '“ 每个团队的风格是？哪个团队的业绩最好？”',
  },
  {
    label: '人员最近变动',
    value: '人员最近变动',
    placeholder: '“有人离开吗？最近都有谁走了 ”',
  },
]
export { alphaRenzhiFields, cateRenzhiFields }
